export enum OrganizationTypeName {
  DISTRIBUTOR = 'Distributor',
  COMPANY = 'Company',
  SITE = 'Site'
}
